import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setAuth } from "../utils/auth";

function getRoleFromToken(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const roles = payload.roles || [];

    if (roles.length === 0) return null;

    // convert ROLE_PUBLIC → PUBLIC
    return roles[0].replace("ROLE_", "");
  } catch {
    return null;
  }
}

export default function OAuthSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const redirectTo = params.get("redirect") || "/user-dashboard";

    if (!token) {
      navigate("/login");
      return;
    }

    const role = getRoleFromToken(token);

    setAuth(token, null, role);

    navigate(redirectTo);
  }, []);

  return <h3 className="text-center mt-5">Logging you in...</h3>;
}
